import api from "./api";

export function getBlogs(page = 1, limit = 10, search = "") {
  return api.get(`/blog?page=${page}&limit=${limit}&search=${search}`);
}

export function getBlogById(id) {
  return api.get(`/blog/${id}`);
}

export function createBlog(data) {
  return api.post("/blog", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateBlog(country_id, data) {
  return api.put(`/blog/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteBlog(id) {
  return api.delete(`/blog/${id}`);
}